import React from "react";
import { PropTypes } from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import { Box } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.components.MuiButton.styleOverrides.root,
    ...theme.typography.body1,
    display: "flex",
    textDecoration: "none",
    lineHeight: 1.75,
    "&:hover": {
      backgroundColor: theme.palette.action.hover
    }
  }
}));
const LinkButton = ({ href, text, download, endAdornment }) => {
  const classes = useStyles();
  return (
    <a className={classes.root} href={href} download={download}>
      <Box display="flex" alignItems="center">
        {text}
        {!!endAdornment && (
          <Box display="flex" pb={0.5} pl={1.75}>
            {endAdornment}
          </Box>
        )}
      </Box>
    </a>
  );
};

export default LinkButton;

LinkButton.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  download: PropTypes.bool,
  endAdornment: PropTypes.node
};
